export const SWIGGY_MONEY = "swiggy_money";
export const ORIGINAL_BUSINESS_LINE = "original_business_line";
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SM_ROUTES {
    LEDGER_PATH = "/ledger",
    VOUCHER_PATH = "/voucher",
    HOW_IT_WORKS_PATH = "/how-it-works",
    FAQ_PATH = "/faq",
    PAYMENTS = "/payments",
    GIFT_CARD_SELECTION = "/gift-card/selection",
    GIFT_CARD_SHARING = "/gift-card/sharing",
    GIFT_CARD_PAYMENTS = "/gift-card/payments",
    GIFT_CARD_REDEMPTION = "/gift-card/redemption",
}
export const PORTAL_SWIGGY_MONEY = "portal_swiggy_money";

export const GIFT_CARD_SHARE_MESSAGE = "Hey! I have sent you a gift card on Swiggy! 🥳";

export const CLICK_THIS_LINK = "Tap the below link to claim it:";

export const EXPIRY_MESSAGE = "It expires on 28th February, 2026, so claim it before that!";

export const MESSAGE_FOOTNOTE =
    "PS: You can use Swiggy Money for all orders across Swiggy (Food, Instamart, Dineout & more!). Happy Swiggying!";

export const NEW_RELIC_APPLICATION_ID = process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID || "";
